import Vue from 'vue'

export default {
	UPDATE_LOGIN_STATE (state, payload) {
		Vue.set(state, payload.field, payload.value)
	}
}
